import { useState, useEffect, useRef, useCallback, useContext } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Draggable } from "react-beautiful-dnd";
import { Row, Col, Button, Card } from "react-bootstrap";
import { UserThumbnails, ContentLabel, CardTag, ProgressIcon, StopWatch, RedDot, EditIcon, TimeIcon, DateTimeInlineEdit } from '../../../../components';
import { adminBaseURL } from '../../../../utils/commonUtils';
import DueDateIcon from '../../../../images/icons/due-date.svg';
import LoadiGif from "../../../../images/loading_image.gif";
import { dateTimeFormatter } from '../../../../utils';
import { assigned_userActions, content_groupActions } from '../../../../actions/';
import { WorkspaceShowContext } from "../../../../contexts/WorkspaceShowContext";
import { DraftCommentIcon } from '../../../../components';
import { hasDraft } from '../../../../utils/isDraftHasValue';
import { ContentGroupSettings } from '../../../../components/content_group_settings';
import { CardSubtaskStats } from '../../../../components/content_group/CardSubtaskStats';
import { CardTimerStats } from '../../../../components/content_group/CardTimerStats';
import { CardRevisionCount } from '../../../../components/content_group/CardRevisionCount';
import { CONTENT_GROUP_PARTICIPANTS } from '../../../../constants';
import useIsCardVisited from '../../../../hooks/useIsCardVisited';

function CardGroup(props) {
  const {
          item,
          stage,
          index,
          can_crud_content_group,
          workspace_id,
          can_access_move_content_board,
          can_access_show_content_details,
          can_access_edit_label ,
          organization_id
        } = props;
  const dispatch = useDispatch();
  const workspaceBaseUrl = adminBaseURL("workspaces");
  const replace_board = useSelector(state => state.content_group.replace_image);
  const { 
    can_access_clone_content_group, 
    can_access_content_destroy, 
    can_access_content, 
    can_access_add_change_date ,
    can_access_assigned_user
  } = useSelector(state => state.work_space);

  const {
    handleOpenContentGroupPopUp,
    handleOpenLabelDrpdwn,
    showLabelDrpdwn,
    setShowLabelDrpdwn,
    labelDrpdwnContainerRef,
    labelDrpdwnValues,
    setLabelDrpdwnValues,
    handleInlineEdit
  } = useContext(WorkspaceShowContext);

  const {
    isCardVisited
  } = useIsCardVisited();

  useEffect(() => {
    replace_board && replace_board.map((data, i) => {
      if(data && data.attachment) {
        var replaceImage = document.querySelector(`#find_div_board_${data.id} .kanban-card_image img`);
        if (!!replaceImage) {
          replaceImage.src = data.attachment.small.url;
        }
      }
    })
  }, [replace_board])

  const handleLabelDelete = (label_id, e) => {
    e.stopPropagation();

    let requestParams = { label_id: label_id, assigned: false }
    let callback = () => {}
    let content_popup_notification = undefined;

    dispatch(content_groupActions.assignContentLabelToContentGroup(workspace_id, item?.id, requestParams, content_popup_notification, callback))
  }

  let drpdwnContainerRef = useRef();

  useEffect(() => {
    if(item.id === labelDrpdwnValues.content_group_id){
      setLabelDrpdwnValues((prevState) => ({ ...prevState, labels: item?.labels }))
    }
  }, [item?.labels])

  const handleClickLabel = (e, item) => {
    if(!can_access_edit_label){
      return;
    }

    e.stopPropagation();
    let target_position = drpdwnContainerRef.current?.getBoundingClientRect();

    handleOpenLabelDrpdwn(drpdwnContainerRef.current, item.id, item.labels, labelDrpdwnContainerRef, showLabelDrpdwn, setShowLabelDrpdwn)
  }

  const has_draft = hasDraft(item?.drafts || []);
  const has_unread_comments = item?.unread_comments?.team || item?.unread_comments?.guest;
  const name_style = has_draft ? { maxWidth: `calc(100% - 20px)`, overflowWrap: 'break-word' } : {overflowWrap: 'break-word'}

  {/* Participant Modal */}
  const participantModalTarget = useRef(null);
  const openParticipantsModal = useCallback(() => {
    if(!can_access_assigned_user){
      return;
    }

    const onSuccess = (response) => {
      const boundary = participantModalTarget.current?.getBoundingClientRect();

      dispatch({ type: CONTENT_GROUP_PARTICIPANTS.OPEN_PARTICIPANTS_MODAL, payload: { boundary, content_group_id: item.id } })
    }

    const params = {
      content_group_id: item.id,
      workspace_id,
      onSuccess
    }

    dispatch(assigned_userActions.newAssignedUserForPopup(params))
  }, [dispatch, item.id, workspace_id, participantModalTarget.current, can_access_assigned_user]);
  {/* END Participant Modal */}
  

  const renderTitle = () => {
    
  }

  return (
    <Draggable
      key={"card_"+item.id}
      draggableId={"card-"+item.id}
      index={index}
      isDragDisabled={can_access_move_content_board ? false : true}
    >
      {(dragProvided, dragSnapshot) => {
        return (
          <div
            ref={dragProvided.innerRef}
            {...dragProvided.draggableProps}
            {...dragProvided.dragHandleProps}
            className={"kanban-card" + (!item || !item.preview ? " kanban-card--no-preview" : "")}
            style={{
              userSelect: "none",
              minHeight: "50px",
              backgroundColor: "#fff",
              ...dragProvided.draggableProps.style,
            }}
          >
            <div className="kanban-card_header">
              <Row>
                <Col style={{ flexGrow: 1 }}>
                  <div className="d-flex justify-content-between">
                    <div className={` ${item.stage?.require_approval_from_client && item.stage?.submitted ? 'w-100' : 'w-100'}`}>
                      {
                        stage?.enable_timestamp &&
                        <div className='d-flex align-items-center'>
                          <UserThumbnails
                            users={item?.timestamp_info?.users || []}
                            organization_id={organization_id}
                            workspace_id={workspace_id}
                            size={'small'}
                            openUserSummary={true}
                            className={'mb-1 me-3'}
                          />
                          <StopWatch
                            initialTime={item.timestamp_info?.latest_change_total_seconds || 0}
                            initialStartDate={item.timestamp_info?.latest_start}
                            isActive={stage?.enable_timestamp && item.timestamp_info?.active}
                            viewMode={'KANBAN'}
                          />
                        </div>
                      }
                      <div className='kanban-card_header__info d-flex align-items-center justify-content-between align-items-center w-100 position-relative'>
                        <CardTag
                          completed={item?.completed}
                          due_date={item?.due_date}
                          className={"mb-2"}
                          reminder_in_day={item?.reminder_in_day}
                          can_access_content={can_access_content}
                          workspace_id={workspace_id}
                          card_id={item?.id}
                        />
                        <div className='d-flex align-items-center'>
                          {
                            item.stage?.require_approval_from_client && item.stage?.submitted  &&
                              <div>
                                <ProgressIcon content_group={item} size={'md'}/>
                              </div>
                              
                          }

                          {
                            (can_access_clone_content_group || can_access_content_destroy) &&
                            !item.stage.enable_timestamp &&
                              <ContentGroupSettings
                                workspace_id={workspace_id}
                                content_group_id={item.id}
                                stage_id={item.stage_id}
                                can_destroy={can_access_content_destroy}
                                can_clone={can_access_clone_content_group}
                              />
                          }
                        </div>

                      </div>
                      
                      
                      <div
                        className='d-flex align-items-center'
                      >
                        <div
                          onClick={() => handleOpenContentGroupPopUp(item.id)}
                          className={`${isCardVisited(item.id) ? 'text-blue' : ''} w-100 word-break kanban-card_header-title`}
                        >
                          {item.name}
                          <RedDot className={`mx-1 ${ has_unread_comments ? '' : 'd-none' }`}/>
                          {has_draft && <DraftCommentIcon className={'mx-1'} />}
                          
                        </div>
                      </div>   
                    </div>
                  </div>
                </Col>


              </Row>
            </div>
            <div
              data-image-pending={item.preview && item.preview.content_attachment && item.preview.content_attachment_type != "application/pdf" ? 'true' : 'false'}
              data-id={item.id}
              id={`find_div_board_${item.id}`}
              className="visible_board_div"
            >
              {item && item.preview && item.preview.content_attachment_type == "application/pdf" ?
                  <div className="kanban-card_image text-center">
                    <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                  </div>
                :
                  item.preview && item.preview.content_attachment &&
                    <div className="kanban-card_image">
                      <img src={LoadiGif }  alt="content" className="img-fluid"/>
                    </div>
              }
              <div className="kanban-card_body">
                { item && item.labels && item.labels.length > 0 &&
                  <div className="mb-2 d-flex align-items-center">
                    <div
                      ref={drpdwnContainerRef}
                    >
                      { item.labels.map((label, index) => (
                        <ContentLabel
                          id={label.id}
                          editable={can_access_edit_label}
                          name={label.name}
                          color_hex={label.color_hex}
                          key={index}
                          handleDelete={handleLabelDelete}
                          onClick={(e) => handleClickLabel(e, item) }
                          sharesPopup
                        />
                      )) }
                    </div>
                  </div>
                }

                {can_access_show_content_details &&
                  <div 
                    className="d-flex mb-2 align-items-center justify-content-between"
                    ref={participantModalTarget}
                    onClick={ openParticipantsModal }
                  >
                    { item?.assigned_users?.length > 0 &&
                      <div 
                        className={ "kanban-card__participants-wrapper d-flex align-items-center " + ( item.assigned_users.length > 1 ? " kanban-card__participants-wrapper--full" : "" ) }

                      >
                        <UserThumbnails
                          users={item.assigned_users}
                          workspace_id={workspace_id}
                          organization_id={ organization_id }
                          openUserSummary={true}
                          hoverableOnly={true} 
                        />
                      </div>
                    }
                  </div>
                }
                {
                  item?.due_date && 

                  <div className="kanban-card_body-date mb-2">
                    <div className="d-flex align-items-center">
                        <img src={DueDateIcon} height="14" className="attribute-icon due_date-icon" />
                        { can_access_add_change_date ?
                            <DateTimeInlineEdit
                              content_group_date={item.due_date}
                              type="due_date"
                              handleInlineEdit={(handleOnBlur, due_date, setIsDisabled) => handleInlineEdit(handleOnBlur, due_date, item.id, setIsDisabled)}
                            />
                          :(dateTimeFormatter(item.due_date))
                        }
                      </div>
                  </div>
                }

                <div className='d-flex align-items-center justify-content-between'>
                  <CardSubtaskStats 
                    completed={item?.completed_subtasks} 
                    total={item?.total_subtasks} 
                    withIcon={true}
                  />
                  
                  <CardTimerStats 
                    initialTime={item?.total_timestamp_info?.total_seconds || 0}
                    initialStartDate={item?.total_timestamp_info?.latest_start}
                    withIcon={true}
                  />
                  <CardRevisionCount
                    count={item?.revision_count}
                    withIcon={true}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
}

export default CardGroup
